module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-6.2a729ae5.png";